import getBuyerAPIDomain from "./getBuyerAPIDomain";

export enum NUMBER_OF_DAYS_OPTIONS {
  "24HOURS" = "1",
  "7DAYS" = "7",
  "14DAYS" = "14",
  "30DAYS" = "30",
  "90DAYS" = "90",
  "6MONTHS" = "180",
  "1YEAR" = "365",
}

export enum SORT_OPTIONS {
  "SaleDateDescending" = "SaleDateDescending",
  "SaleDateAscending" = "SaleDateAscending",
  "RegistrationNumberAscending" = "RegistrationNumberAscending",
  "RegistrationNumberDescending" = "RegistrationNumberDescending",
  "DescriptionAscending" = "DescriptionAscending",
  "DescriptionDescending" = "DescriptionDescending",
}

export type SortOptionsTypes = `${SORT_OPTIONS}`;

export interface PurchasesUrlQueryParams {
  numberofDays?: NUMBER_OF_DAYS_OPTIONS | string;
  pageSize?: number;
  page?: number;
  q?: string;
  sort?: SortOptionsTypes;
  additionalFilters?: { bq: string };
}

const buildGetPurchasesUrl = (
  queryParams: PurchasesUrlQueryParams,
  isToUseAuthZero = false
  ) => {
  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);
  const url = new URL(`${buyerAPIDomain}/saleresults/list?type=Won`);
  Object.keys(queryParams).forEach((param) => {
    if (queryParams[param] !== "" && param !== "additionalFilters") {
      url.searchParams.set(param, queryParams[param].toString());
    }
  });
  url.searchParams.set("bq", queryParams.additionalFilters.bq);
  return url.href;
};

export default buildGetPurchasesUrl;
